import { Button, CircularProgress } from "@mui/joy";
import useDetectIOS from "hooks/useDetectIOS";
import apple_logo from "static/image/common/apple_logo.png";
import google_logo from "static/image/common/google_logo.png";
import { theme } from "styles/theme";

export default function LoginButtonTemplateV3({
  loginType,
  action,
  isLoggedIn,
  isLoading,
  widthPx,
  heightPx,
}: {
  loginType?: "apple" | "google";
  action: () => void;
  isLoggedIn: boolean;
  isLoading?: boolean;
  widthPx?: number | string;
  heightPx?: number | string;
}) {
  const disabled = isLoading;
  const { isIOS } = useDetectIOS();

  const loginDataByType: {
    [key in "apple" | "google"]: {
      logo?: string;
      buttonText: string;
      backgroundColor: string;
      color: string;
      borderColor?: string;
    };
  } = {
    apple: {
      logo: apple_logo,
      buttonText: "Apple로 시작하기",
      backgroundColor: theme.vars.palette.Surface.Forward,
      color: theme.vars.palette.Content.Strong,
      borderColor: "none",
    },
    google: {
      logo: google_logo,
      buttonText: "Google로 시작하기",
      backgroundColor: theme.vars.palette.Surface.Forward,
      color: theme.vars.palette.Content.Strong,
      borderColor: "none",
    },
  };

  const type = loginType ? loginType : isIOS ? "apple" : "google";

  const currentLoginData = loginDataByType[type];

  return (
    <Button
      onClick={!disabled ? action : () => {}}
      variant={"Plain"}
      color={"neutral"}
      size="lg"
      disabled={disabled}
      sx={{
        backgroundColor: currentLoginData.backgroundColor,
        color: currentLoginData.color,
        width: widthPx,
        height: heightPx,
        "&:focus": {
          backgroundColor: currentLoginData.backgroundColor,
          color: currentLoginData.color,
        },
      }}
      startDecorator={
        isLoading ? (
          <CircularProgress variant={"Soft"} />
        ) : (
          <img
            src={currentLoginData.logo}
            alt={"empty"}
            className="w-[20px] "
          />
        )
      }
    >
      {isLoading
        ? "로그인 중..."
        : !isLoggedIn
          ? currentLoginData.buttonText
          : "로그인 완료"}
    </Button>
  );
}
